import React, { useContext } from 'react'
import styled from '@emotion/styled'
import TextField from '@mui/material/TextField'
import { useStore } from '../../Store'
import Button from '@mui/material/Button'
import { ConfigContext } from '../../Store/ConfigContext'
import { validateMember } from './../../Utils/validateMember'

const InputStyle = styled(TextField)(({ theme }) => ({
  width: '100%',
  [theme.breakpoints.only('xs')]: {
    marginTop: '0.5rem',
  },
}))

const ButtonStyle = styled(Button)({
  width: '100%',
  marginBottom: '2rem',
  marginTop: '1rem',
})

export const TitleStyle = styled('h3')(({ theme }) => ({
  fontSize: '1rem',
  color: theme.palette.primary.main,
  padding: '0',
  margin: '0',
  marginTop: '2rem',
  [theme.breakpoints.only('xs')]: {
    fontSize: '1rem',
  },
}))

const ParragraphStyle = styled('p')(({ theme }) => ({
  fontSize: '0.8rem',
  color: theme.palette.primary.main,
  padding: '0',
  margin: '1em 0',
  textAlign: 'justify',
}))

function MemberValidation(props) {
  const { values, handleChange, setFieldValue, errors } = props.formikProps

  const { setLoading, setIsMember, isMember, setAlertMessage } = useStore(
    (state) => ({
      setLoading: state.setLoading,
      setIsMember: state.setIsMember,
      isMember: state.isMember,
      setAlertMessage: state.setAlertMessage,
    })
  )

  const {
    texts,
    withoutMemberValidation,
    memberValidationEndpoint,
    isMemberKeyEmail,
    clientName,
    withoutUserNameField,
  } = useContext(ConfigContext)

  console.log('ERRORS: ', errors)

  if (withoutUserNameField) {
    return null
  }

  return (
    <>
      {!props.withoutTitle && (
        <TitleStyle>
          {texts?.membersSectionTitle || 'Members validation'}{' '}
        </TitleStyle>
      )}
      <ParragraphStyle>
        {texts?.membersSectionDescription ||
          'Members receive special pricing. If you are a Member, capture your email address'}
      </ParragraphStyle>
      <InputStyle
        id="memberEmail"
        name="memberEmail"
        label={texts?.memberSectionPlaceholder || 'Member email'}
        variant="outlined"
        value={values.memberEmail}
        size="small"
        // focused
        onChange={handleChange}
        error={!!errors?.memberEmail}
        helperText={errors?.memberEmail && errors?.memberEmail}
        disabled={withoutMemberValidation ? false : !!isMember}
      />
      {!withoutMemberValidation && memberValidationEndpoint ? (
        <ButtonStyle
          onClick={() => {
            if (isMemberKeyEmail) {
              if (
                /[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}/gm.test(
                  values.memberEmail
                )
              ) {
                validateMember(
                  values.memberEmail,
                  setLoading,
                  setFieldValue,
                  setIsMember,
                  setAlertMessage,
                  memberValidationEndpoint,
                  clientName
                )
              } else {
                setAlertMessage(`This field should have an email format`)
              }
            } else {
              validateMember(
                values.memberEmail,
                setLoading,
                setFieldValue,
                setIsMember,
                setAlertMessage,
                memberValidationEndpoint,
                clientName
              )
            }
          }}
          variant="contained"
          color={isMember ? 'secondary' : 'primary'}
          disabled={!!isMember}
        >
          {isMember
            ? `Welcome ${isMember.lastName ? 'Mr. ' + isMember.lastName : ''}`
            : texts?.membersSectionButton || 'Validate Member Email'}
        </ButtonStyle>
      ) : (
        <div style={{ height: '2rem' }} />
      )}
    </>
  )
}

export default MemberValidation
